var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-date-picker',{attrs:{"value":_vm.getRange(_vm.query),"mode":"range","color":"green","input-props":{
    placeholder: _vm.placeholder
  },"popover":{
    visibility: 'focus'  
  },"locale":{
    id: 'en',
    masks: {
      input: 'MM/DD/YYYY',
      data: 'MM/DD/YYYY'
    }  
  }},on:{"input":_vm.onChange},scopedSlots:_vm._u([{key:"default",fn:function({ inputProps, inputEvents }){return _c('input',_vm._g(_vm._b({staticClass:"form-control",attrs:{"placeholder":_vm.placeholder},on:{"keydown":_vm.onKeyDown}},'input',inputProps,false),inputEvents))}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }